import React from "react";
import { headerSortingClasses, sortCaret } from "../../_metronic/_helpers";
import { formatCurrency, formatQuantity, formatDate } from "../utility";
import { NavLink } from "react-router-dom";

export const columnsReturn = [
  {
    text: "No",
    dataField: "no",
    sort: true,
    sortCaret: sortCaret,
    headerSortingClasses,
    style: { minWidth: "70px" },
    footer: "",
  },
  {
    text: "product code",
    dataField: "product_code",
    sort: true,
    sortCaret: sortCaret,
    headerSortingClasses,
    style: { minWidth: "180px" },
    footer: "",
    formatter: (cell, row) => {
      return (
        <div>
          <span>
            <NavLink
              className="menu-link"
              to={`/master/product/edit/${row.product_id}`}
            >
              <b> {row.product_code}</b>
            </NavLink>
          </span>
        </div>
      );
    },
  },
  {
    text: "product name",
    dataField: "product_name",
    sort: true,
    sortCaret: sortCaret,
    headerSortingClasses,
    style: { minWidth: "180px" },
    footer: "",
  },
  {
    text: "retur date",
    dataField: "retur_date",
    sort: true,
    sortCaret: sortCaret,
    headerSortingClasses,
    style: { minWidth: "180px" },
    formatter: formatDate,
    footer: "",
  },
  {
    text: "remarks",
    dataField: "remarks_return",
    sort: true,
    sortCaret: sortCaret,
    headerSortingClasses,
    style: { minWidth: "180px" },
    footer: "",
  },

  {
    text: "ok",
    dataField: "ok_quantity",
    sort: true,
    sortCaret: sortCaret,
    headerSortingClasses,
    style: { minWidth: "100" },
    formatter: formatQuantity,
    align: "right",
    footer: "",
  },
  {
    text: "damage",
    dataField: "dmg_quantity",
    sort: true,
    sortCaret: sortCaret,
    headerSortingClasses,
    style: { minWidth: "100" },
    formatter: formatQuantity,
    align: "right",
    footer: "",
  },
  {
    text: "expired",
    dataField: "exp_quantity",
    sort: true,
    sortCaret: sortCaret,
    headerSortingClasses,
    style: { minWidth: "100" },
    formatter: formatQuantity,
    align: "right",
    footer: "",
  },

  {
    text: "total quantity",
    dataField: "total_quantity",
    sort: true,
    sortCaret: sortCaret,
    headerSortingClasses,
    style: { minWidth: "180px" },
    formatter: formatQuantity,
    align: "right",
    footer: "",
  },

  {
    text: "uom",
    dataField: "uom_description",
    sort: true,
    sortCaret: sortCaret,
    headerSortingClasses,
    style: { minWidth: "180px" },
    footer: "",
  },

  {
    text: "unit price",
    dataField: "unit_price",
    sort: true,
    sortCaret: sortCaret,
    headerSortingClasses,
    style: { minWidth: "180px" },
    formatter: formatCurrency,
    align: "right",
    footer: "",
  },
  {
    text: "total price",
    dataField: "total_price",
    sort: true,
    sortCaret: sortCaret,
    headerSortingClasses,
    style: { minWidth: "180px" },
    formatter: formatCurrency,
    align: "right",
    footer: (columnData) => {
      const parsedData = columnData.map((item) => parseFloat(item));
      const total = parsedData.reduce((acc, item) => acc + item, 0);
      if (total === 0) {
        return null; // Menyembunyikan footer jika total harga adalah 0
      }
      return formatCurrency(total);
    },
    footerAlign: (column, colIndex) => "right",
  },
];

export const columnsReturnHidden = [
  {
    text: "No",
    dataField: "no",

    style: { minWidth: "70px" },
  },
  {
    text: "product code",
    dataField: "product_code",

    style: { minWidth: "180px" },
  },
  {
    text: "product name",
    dataField: "product_name",

    style: { minWidth: "180px" },
  },
  {
    text: "retur date",
    dataField: "retur_date",
    style: { minWidth: "180px" },
  },
  {
    text: "remark",
    dataField: "remarks_return",
    style: { minWidth: "180px" },
  },
  {
    text: "ok",
    dataField: "ok_quantity",

    style: { minWidth: "100" },

    align: "right",
  },
  {
    text: "damage",
    dataField: "dmg_quantity",

    style: { minWidth: "100" },

    align: "right",
  },
  {
    text: "expired",
    dataField: "exp_quantity",

    style: { minWidth: "100" },

    align: "right",
  },

  {
    text: "total quantity",
    dataField: "total_quantity",

    style: { minWidth: "180px" },

    align: "right",
  },
    {
    text: "uom",
    dataField: "uom_description",

    style: { minWidth: "180px" },

    align: "right",
  },
  {
    text: "unit price",
    dataField: "unit_price",

    style: { minWidth: "180px" },

    align: "right",
  },
  {
    text: "total price",
    dataField: "total_price",

    style: { minWidth: "180px" },

    align: "right",
  },
];

export const columnsOrder = [
  {
    text: "No",
    dataField: "no",
    sort: true,
    sortCaret: sortCaret,
    headerSortingClasses,
    style: { minWidth: "70px" },
    footer: "",
  },
  {
    text: "product code",
    dataField: "product_code",
    sort: true,
    sortCaret: sortCaret,
    headerSortingClasses,
    style: { minWidth: "180px" },
    footer: "",
    formatter: (cell, row) => {
      return (
        <div>
          <span>
            <NavLink
              className="menu-link"
              to={`/master/product/edit/${row.product_id}`}
            >
              <b> {row.product_code}</b>
              {/* <span>{row.product_name}</span> */}
            </NavLink>
          </span>
        </div>
      );
    },
  },
  {
    text: "product name",
    dataField: "product_name",
    sort: true,
    sortCaret: sortCaret,
    headerSortingClasses,
    style: { minWidth: "180px" },
    footer: "",
  },
  {
    text: "unit price",
    dataField: "unit_price",
    sort: true,
    sortCaret: sortCaret,
    headerSortingClasses,
    style: { minWidth: "180px" },
    formatter: formatCurrency,
    align: "right",
    footer: "",
  },
  {
    text: "price discount",
    dataField: "discount_amount",
    sort: true,
    sortCaret: sortCaret,
    headerSortingClasses,
    style: { minWidth: "180px" },
    formatter: formatCurrency,
    align: "right",
    footer: "",
  },
  {
    text: "qty",
    dataField: "quantity",
    sort: true,
    sortCaret: sortCaret,
    headerSortingClasses,
    style: { minWidth: "180px" },
    formatter: formatQuantity,
    align: "right",
    footer: "",
  },
  {
    text: "uom",
    dataField: "uom_description",
    sort: true,
    sortCaret: sortCaret,
    headerSortingClasses,
    style: { minWidth: "180px" },
    footer: "",
  },

  {
    text: "total price",
    dataField: "total_price",
    sort: true,
    sortCaret: sortCaret,
    headerSortingClasses,
    style: { minWidth: "180px" },
    formatter: formatCurrency,
    align: "right",
    formatter: formatCurrency,
    align: "right",
    footer: (columnData) => {
      const parsedData = columnData.map((item) => parseFloat(item));
      const total = parsedData.reduce((acc, item) => acc + item, 0);
      if (total === 0) {
        return null; // Menyembunyikan footer jika total harga adalah 0
      }
      return formatCurrency(total);
    },
    footerAlign: (column, colIndex) => "right",
  },
];

export const columnsOrderHidden = [
  {
    text: "No",
    dataField: "no",

    style: { minWidth: "70px" },
  },
  {
    text: "product code",
    dataField: "product_code",

    style: { minWidth: "180px" },
  },
  {
    text: "product name",
    dataField: "product_name",
    style: { minWidth: "180px" },
  },
  {
    text: "unit price",
    dataField: "unit_price",
    style: { minWidth: "180px" },
    align: "right",
  },
  {
    text: "price discount",
    dataField: "discount_amount",
    sort: true,
    sortCaret: sortCaret,
    headerSortingClasses,
    style: { minWidth: "180px" },
    formatter: formatCurrency,
    align: "right",
  },
  {
    text: "price after discount",
    dataField: "price_after_discount",
    sort: true,
    sortCaret: sortCaret,
    headerSortingClasses,
    style: { minWidth: "180px" },
    formatter: formatCurrency,
    align: "right",
  },
  {
    text: "price discount",
    dataField: "discount_amount",
    style: { minWidth: "180px" },
    align: "right",
  },
  {
    text: "qty",
    dataField: "quantity",

    style: { minWidth: "180px" },

    align: "right",
  },

  {
    text: "uom",
    dataField: "uom_description",
    style: { minWidth: "180px" },
  },
  {
    text: "total price",
    dataField: "total_price",

    style: { minWidth: "180px" },

    align: "right",

    align: "right",
  },
];

export const columnsPayment = [
  {
    text: "No",
    dataField: "no",
    sort: true,
    sortCaret: sortCaret,
    headerSortingClasses,
    style: { minWidth: "70px" },
    footer: "",
  },
  {
    text: "type",
    dataField: "customer_payment_type",
    sort: true,
    sortCaret: sortCaret,
    headerSortingClasses,
    style: { minWidth: "180px" },
    footer: "",
  },
  {
    text: "payment date",
    dataField: "payment_date",
    sort: true,
    sortCaret: sortCaret,
    headerSortingClasses,
    style: { minWidth: "180px" },
    formatter: formatDate,
    footer: "",
  },
  {
    text: "total amount",
    dataField: "order_total",
    sort: true,
    sortCaret: sortCaret,
    headerSortingClasses,
    style: { minWidth: "180px" },
    formatter: formatCurrency,
    align: "right",
    footer: "",
  },
  {
    text: "return amount",
    dataField: "order_retur",
    sort: true,
    sortCaret: sortCaret,
    headerSortingClasses,
    style: { minWidth: "180px" },
    formatter: formatCurrency,
    align: "right",
    footer: "",
  },
  {
    text: "payment amount",
    dataField: "payment_amount",
    sort: true,
    sortCaret: sortCaret,
    headerSortingClasses,
    style: { minWidth: "180px" },
    formatter: formatCurrency,
    align: "right",
    footer: (columnData) => {
      const parsedData = columnData.map((item) => parseFloat(item));
      const total = parsedData.reduce((acc, item) => acc + item, 0);
      if (total === 0) {
        return null; // Menyembunyikan footer jika total harga adalah 0
      }
      return formatCurrency(total);
    },
    footerAlign: (column, colIndex) => "right",
  },
  {
    text: "remaining amount",
    dataField: "order_remain",
    sort: true,
    sortCaret: sortCaret,
    headerSortingClasses,
    style: { minWidth: "180px" },
    formatter: formatCurrency,
    align: "right",
    footer: "",
  },
  {
    text: "total amount",
    dataField: "order_total",
    sort: true,
    sortCaret: sortCaret,
    headerSortingClasses,
    style: { minWidth: "180px" },
    formatter: formatCurrency,
    align: "right",
    formatter: formatCurrency,
    align: "right",
    footer: "",
  },
];

export const columnsPaymentHidden = [
  {
    text: "No",
    dataField: "no",
    sort: true,
    sortCaret: sortCaret,
    headerSortingClasses,
    style: { minWidth: "70px" },
  },
  {
    text: "type",
    dataField: "customer_payment_type",
    sort: true,
    sortCaret: sortCaret,
    headerSortingClasses,
    style: { minWidth: "180px" },
  },
  {
    text: "payment date",
    dataField: "payment_date",
    sort: true,
    sortCaret: sortCaret,
    headerSortingClasses,
    style: { minWidth: "180px" },
    formatter: formatDate,
  },
  {
    text: "total amount",
    dataField: "order_total",
    sort: true,
    sortCaret: sortCaret,
    headerSortingClasses,
    style: { minWidth: "180px" },
    formatter: formatCurrency,
    align: "right",
  },
  {
    text: "return amount",
    dataField: "order_retur",
    sort: true,
    sortCaret: sortCaret,
    headerSortingClasses,
    style: { minWidth: "180px" },
    formatter: formatCurrency,
    align: "right",
  },
  {
    text: "payment amount",
    dataField: "payment_amount",
    sort: true,
    sortCaret: sortCaret,
    headerSortingClasses,
    style: { minWidth: "180px" },
    formatter: formatCurrency,
    align: "right",
  },
  {
    text: "Remaining amount",
    dataField: "order_remain",
    sort: true,
    sortCaret: sortCaret,
    headerSortingClasses,
    style: { minWidth: "180px" },
    formatter: formatCurrency,
    align: "right",
  },
];
